module.exports = __webpack_public_path__ + "img/table_black.a5482468.svg";